module.exports = __webpack_public_path__ + "static/img/alipay-2.622dad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/alipay-2.png
// module id = PLIL
// module chunks = 216